import { createFileRoute, redirect } from "@tanstack/react-router";
import { CargarCFDIPage } from "@/features/cargar-cfdi/components/CargarCFDIPage";
import { pasoActivo, urlPorPaso } from "@/components/solicitudes/stepper/state-mapping";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert } from "@/components/ui";

export const Route = createFileRoute("/_authed-tw/solicitudes/$id/cargar-cfdi")({
  beforeLoad: async ({ context: { queryClient }, params: { id } }) => {
    const sol = await queryClient.ensureQueryData(solicitudQueryOptions(id));
    if (sol.subtipo === "CONTRAPAGO") {
      const paso = pasoActivo(sol.estado, sol.tipo, sol.subtipo, sol.esperaCfdiConciliadoAt);
      const destino = paso === "terminal-positivo" ? `/solicitudes/${id}` : (urlPorPaso(paso, id, false, true) ?? `/solicitudes/${id}`);
      throw redirect({ to: destino as never });
    }
  },
  loader: ({ context: { queryClient }, params: { id } }) => queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: CargarCFDIPage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
